var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PublicityDetail6"},[_c('h3',[_vm._v("3·15金融消费者权益保护教育宣传活动丨保障金融权益 助力美好生活")]),_c('img',{attrs:{"src":require('../images/ic_publicity_detail6_1.jpg')}}),_c('br'),_c('img',{attrs:{"src":require('../images/ic_publicity_detail6_2.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }